import AdventureBookingForm from "@/components/feature/AdventureBookingForm";

export default function BookingRaftingPage() {
  return <AdventureBookingForm activity="rafting" />;
}